import {
    type AcceptedLang,
    LANG_DEFAULT,
    getUrlLang,
    isFullySupportedLangValid,
    isPartiallySupportedLangValid,
    mapUrlToLangCode,
} from '@lingoda/env';
import { sectionNames, transformSectionName } from '@lingoda/sections';
import { type SectionNameTranslation, sectionsTranslationMapping } from '@lingoda/config';

export const shouldFallbackToDefaultLang = (url: string, routeLabel: string | undefined) => {
    const urlLang = getUrlLang(url);
    const lang = mapUrlToLangCode(urlLang ?? LANG_DEFAULT);

    return hasLang(lang) && !isLangValid(lang, routeLabel);
};

const isLangValid = (lang: AcceptedLang, routeLabel: string | undefined) => {
    return isFullySupportedLangValid(lang) || isPartiallySupportedLangValid(lang, routeLabel);
};

const hasLang = (lang: string) => !!lang.length;

export const getFallbackUrl = (currentUrl: string) => {
    const currentLangUrl = getUrlLang(currentUrl);
    const lang = mapUrlToLangCode(currentLangUrl ?? LANG_DEFAULT);
    const currentSectionUrl = currentUrl.split('/')[4];

    let fallbackUrl = currentUrl;

    if (hasSectionToReplace(lang, currentSectionUrl)) {
        const section: SectionName = transformSectionName(currentSectionUrl);
        fallbackUrl = fallbackUrl.replace(`/${currentSectionUrl}/`, `/${section}/`);
    }
    fallbackUrl = fallbackUrl.replace(`/${currentLangUrl}/`, `/${LANG_DEFAULT}/`);

    return fallbackUrl;
};

const hasSectionToReplace = (lang: AcceptedLang, section: string) => {
    const availableSectionsUrl = sectionNames.map(
        (sectionName) => sectionsTranslationMapping[sectionName][lang],
    );

    return availableSectionsUrl.includes(section as SectionNameTranslation);
};
